import { useEffect, useState } from 'react';
import CliError from '../../../utilities/CliError';
import getBuildAttributes from '../../../utilities/getBuildAttributes';
import logForCI from '../../../utilities/logForCI';
import logger from '../../../utilities/logger';
import releaseBuild from '../utilities/releaseBuild';
import useExit from '../../../utilities/useExit';
import { ReleaseBuildState } from '../utilities/types';
import ReleaseBuildView from './ReleaseBuildView';

export default function ReleaseBuildLogic({
  buildId,
  commandUsed,
  configPath,
}: {
  buildId: string;
  commandUsed: string;
  configPath?: string;
}) {
  const exit = useExit();
  const [state, setState] = useState<ReleaseBuildState>({ state: 'loading' });

  useEffect(() => {
    releaseBuildWorkflow({ configPath, buildId, updateState }).catch(
      logger.error,
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function updateState(changes: Partial<ReleaseBuildState>) {
    setState(
      (previousState) =>
        ({ ...previousState, ...changes }) as ReleaseBuildState,
    );
    if (changes.state && ['build-error', 'complete'].includes(changes.state)) {
      setTimeout(() => exit(), 10);
    }
  }

  return <ReleaseBuildView commandUsed={commandUsed} state={state} />;
}

async function releaseBuildWorkflow({
  buildId,
  configPath,
  updateState,
}: {
  buildId: string;
  configPath?: string;
  updateState: (changes: Partial<ReleaseBuildState>) => void;
}) {
  try {
    const { appId, build } = await getBuildAttributes({
      buildId,
      configPath,
    });
    updateState({ build });

    updateState({ state: 'releasing' });
    await releaseBuild({ appId, buildId });

    logForCI('Released!');
    updateState({ state: 'complete' });
  } catch (e) {
    const error = CliError.from(e);
    updateState({ error, state: error.type });
  }
}
